<template>
  <div>
    <b-modal
      ref="manual-discount"
      title="Manual Discount"
      centered
      size="md"
      hide-footer
      modal-class="open-manualdiscount"
      @hidden="closeManualDiscountModal"
    >
      <b-form class="manual-discount" @submit.prevent>
        <b-card no-body class="grey-pills-tabs pt-2">
          <b-tabs pills fill card>
            <b-tab
              title="Select from List"
              active
              v-if="!state.system.isOffline"
            >
              <b-row class="mb-2">
                <b-col md="12">
                  <ul
                    class="custom-checklist list-unstyled"
                    v-if="manualDiscountList.length > 0"
                  >
                    <li
                      v-for="item in manualDiscountList"
                      :key="item.id"
                      class="py-3"
                      :class="{ active: selectedManualDisc === item }"
                      @click="selectedManualDisc = item"
                      v-text="item.name"
                      :id="item.name"
                    ></li>
                  </ul>
                  <div
                    style="min-height: 150px"
                    class="d-flex align-items-center justify-content-center"
                    v-if="manualDiscountList.length == 0"
                  >
                    No data found.
                  </div>
                </b-col>
              </b-row>
              <b-button
                class="float-right"
                variant="primary"
                :disabled="$loading || manualDiscountList.length == 0"
                @click="getDiscountFromList"
                id="apply-manual-discount"
              >
                <span v-if="!$loading">Apply Discount</span>
                <b-spinner small v-if="$loading"></b-spinner>
              </b-button>
            </b-tab>
            <b-tab
              title="Custom Discount"
              :active="manualDiscountList.length == 0"
            >
              <b-row class="mb-2">
                <b-col md="12">
                  <b-form-group
                    class="mb-3"
                    label="Discount type"
                    label-for="discount_type"
                  >
                    <b-form-radio-group
                      id="discount_type"
                      v-model="discount_type"
                      :options="discount_type_options"
                      name="radio-options"
                      :value="discount_type_options.value"
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-group id class="my-2 mx-auto">
                    <label for>Discount Value</label>
                    <input
                      id="discount-value"
                      type="number"
                      size="lg"
                      min="0"
                      autocomplete="off"
                      autofocus
                      class="w-100 form-control"
                      v-model="applyAmount"
                      :placeholder="discount_type == 'A' ? '₹ 0' : '0%'"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                      :disabled="$loading"
                      v-shortkey.focus="['ctrl', 'f']"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                class="float-right"
                variant="primary"
                :disabled="$loading || manualDiscountAmt"
                v-if="discount_type == 'A'"
                @click="getManualDiscount"
                id="apply-discount"
              >
                <span v-if="!$loading">Apply Discount</span>
                <b-spinner small v-if="$loading"></b-spinner>
              </b-button>
              <b-button
                class="float-right"
                variant="primary"
                v-if="discount_type == 'P'"
                :disabled="$loading || manualDiscountPct"
                @click="getPerctangeDiscount"
                id="apply-percentage"
              >
                <span v-if="!$loading">Apply Discount</span>
                <b-spinner small v-if="$loading"></b-spinner>
              </b-button>
            </b-tab>
            <!-- <b-tab title="Amount" active>
              <b-row class="mb-2">
                <b-col md="12">
                  <b-form-group id class="my-2 mx-auto">
                    <label for>Enter discount amount</label>
                    <input
                      type="number"
                      size="lg"
                      autocomplete="off"
                      class="w-100 form-control"
                      min="0"
                      autofocus
                      placeholder="Enter Amount"
                      v-model="applyAmount"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                      :disabled="$loading"
                      v-shortkey.focus="['ctrl','f']"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col>
                  <button
                    class="btn btn-secondary grey-btn float-right w-100"
                    :disabled="manualDiscountAmt || $loading"
                    type="button"
                    @click="getManualDiscount()"
                  >
                    <span v-if="$loading == false">Apply</span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </button>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Percentage">
              <b-row class="mb-2">
                <b-col md="12">
                  <b-form-group id class="my-2 mx-auto">
                    <label for>Enter discount percentage</label>
                    <input
                      type="number"
                      size="lg"
                      min="0"
                      autocomplete="off"
                      autofocus
                      class="w-100 form-control"
                      v-model="applyPercentage"
                      placeholder="0%"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                      :disabled="$loading"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col>
                  <button
                    class="btn btn-secondary grey-btn float-right w-100"
                    :disabled="manualDiscountPct || $loading"
                    type="button"
                    @click="getPerctangeDiscount()"
                  >
                    <span v-if="$loading == false">Apply</span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </button>
                </b-col>
              </b-row>
            </b-tab>-->
          </b-tabs>
        </b-card>
      </b-form>
    </b-modal>
  </div>
</template>
<style lang="scss" scoped>
.input-fields .disabled {
  background-color: #f0f0f0 !important;
}
</style>

<script>
// import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";
export default {
  name: "manual-discount",
  components: {},
  props: {
    open: { type: Boolean, default: false },
    bill_type: { type: String, default: "" },
    pdata: {},
  },
  data() {
    return {
      type: "",
      manualDiscount: [],
      // loading: false,
      // validated: 0,
      applyAmount: "",
      // applyPercentage: "",
      selectedManualDisc: "",
      discount_type: "",
      discount_type_options: [
        { text: "Amount", value: "A" },
        { text: "Percentage", value: "P" },
      ],
      manualDiscountList: [],
    };
  },
  watch: {
    open() {
      if (this.open) {
        console.log(this.bill_type);
        if (!this.state.system.isOffline) this.getDiscountList();
        else this.$refs["manual-discount"].show();
        this.discount_type = "A";
      } else {
        this.$refs["manual-discount"].hide();
      }
    },
  },
  computed: {
    ...mapState({
      state: (state) => state,
      customerData() {
        return this.$store.getters["sessions/getCustomerParam"];
      },
      essentialsData() {
        return this.$store.getters["sessions/getEssentialsData"];
      },
      manualDiscountAmt() {
        if (this.applyAmount != "") {
          if (
            this.state.system.settings.offer.manual_discount.max_amount != "" ||
            this.state.system.settings.offer.manual_discount.max_amount != 0
          ) {
            if (
              parseInt(this.applyAmount) <=
                parseInt(
                  this.state.system.settings.offer.manual_discount.max_amount
                ) &&
              parseInt(this.applyAmount) != 0
            ) {
              if (
                parseInt(this.applyAmount) <
                parseInt(this.state.billing.billing.subtotal)
              ) {
                return false;
              }
            }
          } else {
            if (
              parseInt(this.applyAmount) <
                this.state.billing.billing.cart.total &&
              parseInt(this.applyAmount) != 0
            ) {
              return false;
            }
          }
        }
        return true;
      },
      manualDiscountPct() {
        if (this.applyAmount != "") {
          if (
            this.state.system.settings.offer.manual_discount.max_percentage !=
              "" ||
            this.state.system.settings.offer.manual_discount.max_percentage != 0
          ) {
            if (
              parseInt(this.applyAmount) <=
                parseInt(
                  this.state.system.settings.offer.manual_discount
                    .max_percentage
                ) &&
              parseInt(this.applyAmount) != 0
            ) {
              return false;
            }
          } else {
            if (
              parseInt(this.applyAmount) < 100 &&
              parseInt(this.applyAmount) != 0
            ) {
              return false;
            }
          }
        }
        return true;
      },
    }),
  },

  methods: {
    closeManualDiscountModal() {
      this.$emit("close-manual-discount", false);
    },
    getManualDiscount() {
      this.$loading = true;
      let postData = {
        store_id: this.state.sessions.user.store_id,
        manual_discount_basis: "A",
        remove_discount: "0",
        trans_from: this.state.system.trans_from,
        // api_token: this.state.token,
        manual_discount_factor: this.applyAmount,
        url: "/manual-discount",
        applicable_level: this.bill_type,
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };

      // let md_val = {
      //   basis: postData.manual_discount_basis,
      //   factor: postData.manual_discount_factor,
      // };

      if (this.bill_type == "ITEM_LEVEL")
        postData = Object.assign(postData, { cart_id: this.pdata.cart_id });

      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.$loading = false;
            this.$emit("close-manual-discount", false);
            this.applyAmount = "";
            if (res.data.status == "fail")
              this.alertData(res.data.message, "danger");
            else
              this.alertData(
                this.bill_type == "ITEM_LEVEL"
                  ? "Item level " + msg.MANUAL_DISCOUNT
                  : "Bill level " + msg.MANUAL_DISCOUNT,
                "success"
              );
          });
        })
        .catch(() => {
          this.$loading = false;
          this.alertData(msg.INTERNAL_SERVER_ERROR, "danger");
        });
    },
    getPerctangeDiscount() {
      // this.$refs["manual-discount"].show();
      this.$loading = true;
      let postData = {
        store_id: this.state.sessions.user.store_id,
        manual_discount_basis: "P",
        remove_discount: "0",
        trans_from: this.state.system.trans_from,
        //   api_token: this.state.token,
        manual_discount_factor: this.applyAmount,
        applicable_level: this.bill_type,
        url: "/manual-discount",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };

      // let md_val = {
      //   basis: postData.manual_discount_basis,
      //   factor: postData.manual_discount_factor,
      // };

      if (this.bill_type == "ITEM_LEVEL")
        postData = Object.assign(postData, { cart_id: this.pdata.cart_id });

      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(postData.url, data)
        .then((res) => {
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.$loading = false;
            this.$emit("close-manual-discount", false);
            this.applyAmount = "";
            if (res.data.status == "fail")
              this.alertData(res.data.message, "danger");
            else
              this.alertData(
                this.bill_type == "ITEM_LEVEL"
                  ? "Item level " + msg.MANUAL_DISCOUNT
                  : "Bill level " + msg.MANUAL_DISCOUNT,
                "success"
              );
          });
        })
        .catch(() => {
          this.$loading = false;
          this.alertData(msg.INTERNAL_SERVER_ERROR, "danger");
        });
    },
    getDiscountFromList() {
      this.$loading = true;
      let postData = {
        store_id: this.state.sessions.user.store_id,
        trans_from: this.state.system.trans_from,
        md_id: this.selectedManualDisc.id,
        applicable_level: this.bill_type,
        type: "predefined",
        url: "/manual-discount",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };

      if (this.bill_type == "ITEM_LEVEL")
        postData = Object.assign(postData, { cart_id: this.pdata.cart_id });

      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(postData.url, data)
        .then((res) => {
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.$loading = false;
            this.applyAmount = "";
            if (res.data.status == "fail") {
              this.alertData(res.data.message, "danger");
            } else {
              this.alertData(
                this.bill_type == "ITEM_LEVEL"
                  ? "Item level " + msg.MANUAL_DISCOUNT
                  : "Bill level " + msg.MANUAL_DISCOUNT,
                "success"
              );
              this.$emit("close-manual-discount", false);
            }
          });
        })
        .catch(() => (this.$loading = false));
    },
    getDiscountList() {
      this.$loading = true;
      let postData = {
        applicable_level: this.bill_type,
        url: "/manual-discount-list",
      };
      if (this.bill_type == "ITEM_LEVEL")
        postData = Object.assign(postData, { barcode: this.pdata.barcode });
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          this.$loading = false;
          this.$refs["manual-discount"].show();
          this.manualDiscountList = res.data.manual_discount_list;
          if (this.manualDiscountList.length > 0)
            this.selectedManualDisc = this.manualDiscountList[0];
        })
        .catch(() => {
          this.$loading = false;
          this.alertData(msg.INTERNAL_SERVER_ERROR, "danger");
        });
    },
    alertData(message, type) {
      let alertData = {
        message: message,
        type: type,
      };
      this.$showAlert = true;
      this.$store.commit("notifications/showAlert", alertData);
    },
  },
};
</script>
<style lang="scss" scoped>
.theme-dark .manual-discount {
  .card {
    p {
      color: #606060;
    }
  }
}
.theme-light .manual-discount {
  .card {
    p {
      color: #c0c0c0;
    }
  }
}
</style>
